// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"645b1c40","577":"66a7ac49","956":"4ef289f6"}[chunkId] + ".chunk.css";
};